import React, { useMemo } from 'react';

import { TableCDS } from 'app/shared/componentsRestyled/coreDesignSystem/Table';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import _ from 'lodash';
import PropTypes from 'prop-types';

import useSort from 'hooks/useSort';

import { UnderwritingTestIds } from '../../Underwriting.testIds';

import { qualifiedIncomesTableConfig } from './Incomes.config';
import { tableWrapperStyles } from './Incomes.styles';

const defaultOrder = {
  direction: 'asc',
  id: 'incomeType',
};

const defaultQualifiedIncomes = [];

const QualifiedIncomesTable = ({ isLoading, qualifiedIncomes = defaultQualifiedIncomes }) => {
  const { order, onRequestSort } = useSort(defaultOrder);

  const orderedQualifiedIncomes = useMemo(
    () =>
      _.orderBy(
        qualifiedIncomes,
        [item => item[order.id]?.toString()?.toLowerCase()],
        [order.direction],
      ),
    [qualifiedIncomes, order],
  );

  return (
    <TableCDS
      withNoAvailableMessage
      config={qualifiedIncomesTableConfig}
      customStyles={tableWrapperStyles}
      data={orderedQualifiedIncomes}
      data-testid={UnderwritingTestIds.UW_REPORTS_QUALIFIED_INCOMES_TABLE}
      isCustomDataDefinition={!orderedQualifiedIncomes.length}
      isLoading={isLoading}
      order={order}
      skeletonRows={2}
      onRequestSort={onRequestSort}
    />
  );
};

QualifiedIncomesTable.propTypes = {
  ...WithLoadingPropTypes,
  qualifiedIncomes: PropTypes.array,
};

export default QualifiedIncomesTable;
